import {
  type CroppedAreaPixels,
  type CroppedPreview,
  type OriginalImageSize,
  type ProfileImageCropperContextTypes,
  type ProfileImageCropperReducerState,
  type UploadImage,
} from '../types.js';

export const START_CROPPING = 'START_CROPPING' as const;
export const STOP_CROPPING = 'STOP_CROPPING' as const;
export const RESET_CROPPING_STATE = 'RESET_CROPPING_STATE' as const;
export const UPDATE_CROPPED_PIXELS = 'UPDATE_CROPPED_PIXELS' as const;
export const UPDATE_CROPPED_PREVIEW = 'UPDATE_CROPPED_PREVIEW' as const;
export const UPDATE_ORIGINAL_IMAGE_SIZE = 'UPDATE_ORIGINAL_IMAGE_SIZE' as const;
export const UPDATE_PROCESSING_STATE = 'UPDATE_PROCESSING_STATE' as const;
export const UPDATE_UPLOAD_IMAGE = 'UPDATE_UPLOAD_IMAGE' as const;
export const UPDATE_CONTEXT_PARAMETERS = 'UPDATE_CONTEXT_PARAMETERS' as const;
export const UPDATE_IS_MUTATION_IN_FLIGHT =
  'UPDATE_IS_MUTATION_IN_FLIGHT' as const;

export const CONTEXT_TYPE_AVATAR = 'AVATAR' as const;
export const CONTEXT_TYPE_LOGO = 'LOGO' as const;
export const CONTEXT_TYPE_CONTACT = 'CONTACT' as const;
export const CONTEXT_TYPE_BRAND_CUSTOMIZATION_LOGO =
  'BRAND_CUSTOMIZATION_LOGO' as const;

export type ProfileImageCropperReducerActionPayloads =
  | ProfileImageCropperReducerState[keyof ProfileImageCropperReducerState]
  | StartCroppingActionPayload
  | UpdateContextParametersActionPayload
  | UpdateCroppedPixelsActionPayload
  | UpdateCroppedPreviewActionPayload
  | UpdateOriginalImageSizeActionPayload
  | UpdateProcessingStateActionPayload
  | UpdateUploadActionPayload;

export type ProfileImageCropperReducerActions =
  | ResetCroppingAction
  | StartCroppingAction
  | StopCroppingAction
  | UpdateContextParametersAction
  | UpdateCroppedPixelsAction
  | UpdateCroppedPreviewAction
  | UpdateIsLoading
  | UpdateOriginalImageSizeAction
  | UpdateProcessingStateAction
  | UpdateUploadAction;

export type ProfileImageCropperReducerActionTypes =
  | typeof RESET_CROPPING_STATE
  | typeof START_CROPPING
  | typeof STOP_CROPPING
  | typeof UPDATE_CONTEXT_PARAMETERS
  | typeof UPDATE_CROPPED_PIXELS
  | typeof UPDATE_CROPPED_PREVIEW
  | typeof UPDATE_IS_MUTATION_IN_FLIGHT
  | typeof UPDATE_ORIGINAL_IMAGE_SIZE
  | typeof UPDATE_PROCESSING_STATE
  | typeof UPDATE_UPLOAD_IMAGE;

export type StartCroppingActionPayload = {
  imageDataURL: ProfileImageCropperReducerState['imageDataURL'];
  imageFile: ProfileImageCropperReducerState['imageFile'];
  imageName: ProfileImageCropperReducerState['imageName'];
  imageType: ProfileImageCropperReducerState['imageType'];
};

export type UpdateContextParametersActionPayload = {
  context: ProfileImageCropperContextTypes;
  saveProfileOnUpload: ProfileImageCropperReducerState['saveProfileOnUpload'];
};

export type UpdateCroppedPixelsActionPayload = CroppedAreaPixels;

export type UpdateCroppedPreviewActionPayload = CroppedPreview;

export type UpdateIsLoadingPayload =
  ProfileImageCropperReducerState['isLoading'];

export type UpdateOriginalImageSizeActionPayload = OriginalImageSize;

export type UpdateProcessingStateActionPayload =
  ProfileImageCropperReducerState['cropIsProcessing'];

export type UpdateUploadActionPayload = UploadImage;

type ResetCroppingAction = {
  type: typeof RESET_CROPPING_STATE;
};

type StartCroppingAction = {
  payload: StartCroppingActionPayload;
  type: typeof START_CROPPING;
};

type StopCroppingAction = {
  type: typeof STOP_CROPPING;
};

type UpdateContextParametersAction = {
  payload: UpdateContextParametersActionPayload;
  type: typeof UPDATE_CONTEXT_PARAMETERS;
};

type UpdateCroppedPixelsAction = {
  payload: UpdateCroppedPixelsActionPayload;
  type: typeof UPDATE_CROPPED_PIXELS;
};

type UpdateCroppedPreviewAction = {
  payload: UpdateCroppedPreviewActionPayload;
  type: typeof UPDATE_CROPPED_PREVIEW;
};

type UpdateIsLoading = {
  payload: UpdateIsLoadingPayload;
  type: typeof UPDATE_IS_MUTATION_IN_FLIGHT;
};

type UpdateOriginalImageSizeAction = {
  payload: UpdateOriginalImageSizeActionPayload;
  type: typeof UPDATE_ORIGINAL_IMAGE_SIZE;
};

type UpdateProcessingStateAction = {
  payload: UpdateProcessingStateActionPayload;
  type: typeof UPDATE_PROCESSING_STATE;
};

type UpdateUploadAction = {
  payload: UpdateUploadActionPayload;
  type: typeof UPDATE_UPLOAD_IMAGE;
};
